<template>
  <div class="home">
    <ContactUsForm />
  </div>
</template>

<script>
import ContactUsForm from '../components/elements/ContactUsForm.vue'
export default {
  name: 'Contact',
  metaInfo: {
    title: 'Contact'
  },
  components: {
    ContactUsForm
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  /*background: url('~@/assets/images/global/background-main.jpg') no-repeat center center;*/
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
